import { connect } from 'react-redux'
import VirtualBackgroundPicker, { VirtualBackgroundPickerProps } from './VirtualBackgroundPicker'
import { State } from '../../dataStore/reducers/reducerType'
import { uploadImage } from '../../dataStore/slices/userSettings/userSettingsSlice'

const mapStateToProps = (state: State, props: VirtualBackgroundPickerProps) => ({
    presenterBackground: state.userSettings.presenterBackground,
    
})

const mapDispatchToProps = (dispatch)  => ({
    onFileSelect: file => dispatch(uploadImage(file)),

})

export default connect(mapStateToProps, mapDispatchToProps)(VirtualBackgroundPicker)
